import React, { useState, useEffect } from "react";
import Srcollbar from "react-perfect-scrollbar";
import toastr from "toastr";
import {
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Card,
  Modal,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import { FiPlusCircle, FiEdit3, FiEye, FiMinusCircle } from "react-icons/fi";
import { FaRegTrashAlt, FaCheck } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import MultiSelectWithCheckbox from "app/Components/SearchableSelect/MultiSelectCkeckOption";
import {
  createEvent,
  getAllEvents,
  updateEvent,
  deleteEvent,
  getAllEventsRoHoMine,
} from "app/_services/ehs/ehsEventServices";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { Validation } from "app/_helpers/validation/Validation";
import { FcApprove } from "react-icons/fc";
import { CgMaximize, CgMinimize, CgFileDocument } from "react-icons/cg";
import { IoMdArrowDropleftCircle, IoMdArrowDroprightCircle } from "react-icons/io";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import {
  MeetingScheduler,
  MeetingReviewer,
  MeetingApprover,
} from "app/_pages/_healthSafetyEnvironment/EHSAuditsMeetings/CONSTANT.js";

const initialForm = {
  id: "",
  name: "",
  title: "",
  category: "",
  status: 0,
  templates: [],
  reviewer: "",
};

const initialTemplate = {
  name: "",
  type: "",
};

const initialTemplateTableRow = { value: "" };
const initialTemplateTableColumn = { title: "" };

const categoryOptions = [
  { label: "Internal Audit", value: "Internal Audit" },
  { label: "External Audit", value: "External Audit" },
  { label: "Meeting", value: "Meeting" },
];

const fieldOptions = [
  { label: "Text", value: "text" },
  { label: "Textarea", value: "textarea" },
  { label: "Date", value: "date" },
  { label: "Email", value: "email" },
  { label: "Telephone", value: "tel" },
  { label: "Image", value: "image" },
  { label: "Table", value: "table" },
  { label: "Table (Fixed)", value: "fixedTable" },
  { label: "Heading", value: "heading" },
  { label: "Options", value: "options" },
  { label: "Options with Text", value: "optionsWithText" },
];

const MeetingType = () => {
  const [tableData, setTableData] = useState([]);
  const [showManageModal, setShowManageModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showTableModal, setShowTableModal] = useState(false);
  const [form, setForm] = useState({ ...initialForm });
  const [errorForm, setErrorForm] = useState({ ...initialForm });
  const [errorArray, setErrorArray] = useState([]);
  const [isMinMaxView, setMinMaxView] = useState(true);
  const [meetingType, setMeetingType] = useState({ ...MeetingFormat });
  let [page, setPage] = useState(1);

  const [filterData, setFilterData] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    setFilterData(tableData);
  }, [tableData]);

  const handleChange = (e) => {
    e.preventDefault();
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    if (!searchInput) {
      setFilterData(tableData);
      return;
    }
    let tData = [];
    tData = tableData.filter((data) => {
      return data?.name?.toLowerCase().includes(searchInput?.toLowerCase());
    });
    console.log("check++++++", tData);
    setFilterData(tData);
  }, [searchInput, tableData]);

  const tCount = 9;
  useEffect(() => {
    if (showViewModal || showManageModal) return;

    setForm({ ...initialForm });
    setErrorForm({ ...initialForm });
    setErrorArray([]);
  }, [showViewModal, showManageModal]);

  // useEffect(() => {
  //   getAllEvents().then((response) => {
  //     if (!response?.data) return;

  //     setTableData(response.data);
  //   });
  // }, [setTableData]);

  useEffect(() => {
    getAllEventsRoHoMine().then((response) => {
      if (!response?.data) return;

      setTableData(response.data);
    });
  }, [setTableData]);

  const approveData = CommmonService.debounce(async () => {
    for (const data of tableData) {
      if (data.status === 1) continue;

      await CommmonService.approveReject({
        id: data.id,
        status: 1,
        tableName: "ehsEvent",
      });

      data.status = 1;
    }

    toastr.success("Approved All Entries.");

    setTableData([...tableData]);
  }, 1500);

  const onChange = ({ target: { name, value } }) => {
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const editEvent = (data) => {
    console.log("edit data ", data);
    setForm(data);
    setShowTableModal(false);
    setShowManageModal(true);
    setMinMaxView(true);
  };
  const viewEvent = (data) => {
    console.log("view data ", data);
    setForm(data);
    setShowTableModal(false);
    setShowViewModal(true);
    setMinMaxView(true);
  };

  const deleteEventById = (id) => {
    confirmAlert({
      title: `Delete Event.`,
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const response = await deleteEvent(id);

            if (!response?.status) return toastr.error(response?.message);

            toastr.success(response.message || "Success.");

            tableData.splice(
              tableData.findIndex((data) => data.id === id),
              1
            );

            setTableData([...tableData]);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const onChangeTemplate = (index, name, value) => {
    const newForm = JSON.parse(JSON.stringify(form));
    newForm.templates[index][name] = value;
    if (name === "type") {
      if (value === "table" || value === "options" || value === "optionsWithText") {
        delete newForm.templates[index].rows;
        newForm.templates[index].columns = [{ ...initialTemplateTableColumn }];
      } else if (value === "fixedTable") {
        newForm.templates[index].rows = [{ ...initialTemplateTableRow }];
        newForm.templates[index].columns = [{ ...initialTemplateTableColumn }];
      }
    }
    setForm(newForm);
  };

  const addRow = () =>
    setForm((prevForm) => ({
      ...prevForm,
      templates: [...prevForm.templates, initialTemplate],
    }));

  const addTableRow = (index) =>
    setForm((prevForm) => ({
      ...prevForm,
      templates: prevForm.templates.map((temp, idx) => {
        if (idx !== index) return temp;
        temp.rows = Array.isArray(temp.rows)
          ? [...temp.rows, { ...initialTemplateTableRow }]
          : [{ ...initialTemplateTableRow }];
        return temp;
      }),
    }));

  const addTableColumn = (index) =>
    setForm((prevForm) => ({
      ...prevForm,
      templates: prevForm.templates.map((temp, idx) => {
        if (idx !== index) return temp;
        temp.columns = Array.isArray(temp.columns)
          ? [...temp.columns, { ...initialTemplateTableColumn }]
          : [{ ...initialTemplateTableColumn }];
        return temp;
      }),
    }));

  const deleteTableRow = (index, idx) =>
    setForm((prevForm) => ({
      ...prevForm,
      templates: prevForm.templates.map((temp, i) => {
        if (i !== index) return temp;
        if (temp.rows.length === 1) toastr.warning("Minimum one row required!");
        else temp.rows.splice(idx, 1);
        return temp;
      }),
    }));

  const deleteTableColumn = (index, idx) =>
    setForm((prevForm) => ({
      ...prevForm,
      templates: prevForm.templates.map((temp, i) => {
        if (i !== index) return temp;
        if (temp.columns.length === 1)
          toastr.warning("Minimum one column/option required!");
        else temp.columns.splice(idx, 1);
        return temp;
      }),
    }));

  const onChangeTableRow = (index, idx, name, value) =>
    setForm((prevForm) => ({
      ...prevForm,
      templates: prevForm.templates.map((temp, i) => {
        if (i !== index) return temp;
        temp.rows[idx][name] = value;
        return temp;
      }),
    }));

  const onChangeTableColumn = (index, idx, name, value) =>
    setForm((prevForm) => ({
      ...prevForm,
      templates: prevForm.templates.map((temp, i) => {
        if (i !== index) return temp;
        temp.columns[idx][name] = value;
        return temp;
      }),
    }));

  const deleteRow = (index, data) => {
    if (data.id) {
      data.deleted = true;
      if (form.deletedRows) form.deletedRows.push(data);
      else form.deletedRows = [data];
    }
    form.templates.splice(index, 1);
    setForm({ ...form });
  };

  //   const onSubmit = async () => {
  //     let flag = 0;
  //     const errorObj = Validation(meetingType, rules);
  //     // const errArray = form.templates.map((template) => {
  //     //   const errorTemplate = Validation(
  //     //     JSON.parse(JSON.stringify(template)),
  //     //     templateRules
  //     //   );
  //     //   if (template.columns)
  //     //     errorTemplate.columns = template.columns.map((column) =>
  //     //       Validation(column, templateTableColumnRules)
  //     //     );
  //     //   if (template.rows)
  //     //     errorTemplate.rows = template.rows.map((row) =>
  //     //       Validation(row, templateTableRowRules)
  //     //     );
  //     //   return errorTemplate;
  //     // });

  //     if (meetingType.name.length > 30) errorObj.name = "Max 30 characters allowed!";
  //     if (
  //       !errorObj.name &&
  //       tableData.find(
  //         (data) =>
  //           data.id !== meetingType.id &&
  //           data.name.trim().toLowerCase() === meetingType.name.trim().toLowerCase()
  //       )
  //     )
  //       errorObj.name = `Same Event already exists!`;

  //     // for (const key in errorObj) if (errorObj[key]) flag = 1;
  //     // for (const obj of errArray)
  //     //   for (const key in obj) {
  //     //     if (obj[key] && !Array.isArray(obj[key])) flag = 1;
  //     //     if (Array.isArray(obj[key]))
  //     //       for (const data of obj[key])
  //     //         for (const k in data) if (data[k]) flag = 1;
  //     //   }

  //     setErrorForm(errorObj);
  //     // setErrorArray(errArray);

  //     console.log(form)

  //     if (flag !== 0) return console.log(errorObj, errArray);

  //     if (!meetingType.name.trim())
  //       return setErrorForm((prev) => ({ ...prev, name: "Name is required!" }));

  //     setErrorForm({ ...meetingType });
  //     let response;

  // if (!meetingType.id) response = await createEvent(meetingType);
  // else response = await updateEvent(meetingType.id, meetingType);

  //     if (!response?.status) return toastr.error(response?.message);

  //     toastr.success(response.message || "Success.");

  //     if (!meetingType.id) {
  //       meetingType.id = response.data.id;
  //       tableData.push(meetingType);
  //     } else {
  //       const index = tableData.findIndex((data) => data.id === meetingType.id);
  //       tableData[index] = { ...tableData[index], ...meetingType };
  //     }

  //     setTableData(tableData);
  //     setShowManageModal(false);
  //     if (meetingType.id) setShowTableModal(true);
  //   };

  const onSubmit = async () => {
    let response;
    if (!form.name) {
      setErrorForm((prev) => ({ ...prev, name: "Name is required!" }));
    } else {
      setErrorForm((prev) => ({ ...prev, name: "" }));
    }

    if (!form.meetingLabel) {
      setErrorForm((prev) => ({
        ...prev,
        meetingLabel: "Meeting Level is required!",
      }));
    } else {
      setErrorForm((prev) => ({ ...prev, meetingLabel: "" }));
    }

    if (!form.scheduler) {
      setErrorForm((prev) => ({
        ...prev,
        scheduler: "Scheduler is required!",
      }));
    } else {
      setErrorForm((prev) => ({ ...prev, scheduler: "" }));
    }

    if (!form.approver) {
      setErrorForm((prev) => ({ ...prev, approver: "Approver is required!" }));
    } else {
      setErrorForm((prev) => ({ ...prev, approver: "" }));
    }

    if (form.approver && form.scheduler && form.meetingLabel && form.name)
      if (!form.id)
        // console.log(form.reviewer);
        response = await createEvent({
          ...form,
          reviewer: form.reviewer === "" ? null : form.reviewer,
        });
      else response = await updateEvent(form.id, form);

    if (!response?.status)
      return toastr.error(response?.message || "Fill all fields Properly!!");

    toastr.success(response.message || "Success.");

    if (!form.id) {
      form.id = response.data.id;
      tableData.push(form);
    } else {
      const index = tableData.findIndex((data) => data.id === form.id);
      tableData[index] = { ...tableData[index], ...form };
    }

    setTableData(tableData);
    setShowManageModal(false);
    if (form?.id) setShowTableModal(true);
  };

  const onChangePage = (count) => {
    if (count > 0 && (form?.templates?.length + tCount) / tCount > count) {
      setPage(count);
    }
  };

  return (
    <Card className="training-card compliance-name-table">
      <Card.Body>
        <Card.Title>
          <span
            className="pointer"
            onClick={() => {
              setShowTableModal(true);
            }}
          >
            Meeting Type
          </span>
        </Card.Title>
        <div className="btn-toolbar" style={{ alignItems: "center" }}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Add Event</Tooltip>}
          >
            <span
              className="icons btn-icon font-20 text-cyanBlue pointer"
              onClick={() => {
                setShowManageModal(true);
              }}
            >
              <FiPlusCircle />
            </span>
          </OverlayTrigger>
          {tableData.filter((data) => data.status !== 1).length ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Approve All Entries</Tooltip>}
            >
              <span onClick={approveData} className="btn-icon text-success pointer">
                <FaCheck />
              </span>
            </OverlayTrigger>
          ) : (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">All Entries Approved</Tooltip>}
            >
              <span className="icons btn-icon font-20 text-success">
                <FcApprove size={28} />
              </span>
            </OverlayTrigger>
          )}
        </div>
      </Card.Body>
      <Srcollbar className="trainingManagementFixedHeight">
        {/* //OLD CODE START */}
        {/* <div className="pl-3 pr-3 material-master-table">
          <table className="table table-bordered mb-1">
            <thead>
              <tr>
                <th className="p-2 border font-weight-bold">Event</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((data, index) => (
                <tr key={index}> */}
        {/* <td className="p-2 border">{data.category}</td> */}
        {/* <td className={`p-2 border${data.status !== 1 ? " text-warning" : ""}`}>
                    {data.name}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div> */}
        {/* OLD CODE END */}

        <ListGroup className="list-group-flush">
          {tableData.map((data, index) => (
            <span
              className={`${data.status !== 1 ? "text-warning" : ""}`}
              onClick={() => {
                viewEvent(data);
              }}
              key={index}
            >
              <ListGroupItem key={index}>{data.name}</ListGroupItem>
            </span>
          ))}
        </ListGroup>
      </Srcollbar>

      <Modal
        className=""
        size={"md"}
        show={showManageModal}
        onHide={() => {
          setShowManageModal(false);
        }}
      >
        <Modal.Header className="pt-0 mt-3" closeButton>
          {isMinMaxView ? (
            <Modal.Title>{form.id ? "Edit" : "Add"} Meeting Type</Modal.Title>
          ) : (
            <>
              <div className="d-flex">
                <CgFileDocument size="30" color="#4285f4" className="pr-1" />
                <Modal.Title>{form.title ? form.title : "Untitled Document"}</Modal.Title>

                {!isMinMaxView && (
                  <div className="d-flex minmaxicon">
                    <h3 className="mr-2">
                      <span
                        className="btn btn-type"
                        onClick={() => onChangePage(page - 1)}
                      >
                        {<IoMdArrowDropleftCircle />}
                      </span>{" "}
                      {page}/
                      {(form?.templates?.length + tCount) % tCount === 0
                        ? parseInt((form?.templates?.length + tCount) / tCount) - 1
                        : parseInt((form?.templates?.length + tCount) / tCount)}{" "}
                      <span
                        className="btn btn-type"
                        onClick={() => onChangePage(page + 1)}
                      >
                        {<IoMdArrowDroprightCircle />}
                      </span>
                    </h3>
                    {isMinMaxView ? (
                      <CgMaximize
                        size="20"
                        className="m-1"
                        onClick={() => {
                          setMinMaxView && setMinMaxView(false);
                        }}
                      ></CgMaximize>
                    ) : (
                      <CgMinimize
                        size="20"
                        className="m-1"
                        onClick={() => {
                          setMinMaxView && setMinMaxView(true);
                        }}
                      ></CgMinimize>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </Modal.Header>
        <div className="card overflow-inherit" style={{ boxShadow: "none" }}>
          <div className="card-body overflow-inherit" style={{ padding: "0" }}>
            {/* <Srcollbar className="modalTableFixedheight"> */}
            {isMinMaxView ? (
              <div className="row">
                <div className="col-12">
                  <div className="card overflow-inherit">
                    <div className="card-body overflow-inherit">
                      <Row className="mb-1">
                        <Col md="12">
                          <div className="form-group">
                            <label>Meeting Name </label>
                            <input
                              maxLength={30}
                              type="text"
                              className="form-control"
                              name="name"
                              value={form?.name}
                              onChange={(event) => {
                                // event.persist();
                                const { name, value } = event.target;
                                setForm((prev) => ({
                                  ...prev,
                                  name: value,
                                }));
                              }}
                            />
                            <span className="text-danger small">{errorForm?.name}</span>
                          </div>
                        </Col>

                        <Col md="12">
                          <div className="form-group">
                            <label>Meeting Level</label>
                            <SimpleSelect
                              className="form-control"
                              name="meetingLabel"
                              value={form?.meetingLabel}
                              id="key"
                              label="name"
                              options={MeetingLevel}
                              init="Select"
                              menuPortalTarget={null}
                              onChange={(selected) => {
                                setForm((prev) => ({
                                  ...prev,
                                  meetingLabel: selected.target.value,
                                }));
                              }}
                            ></SimpleSelect>

                            <span className="text-danger small">
                              {errorForm?.meetingLabel}
                            </span>
                          </div>
                        </Col>

                        <Col md="12">
                          <div className="form-group">
                            <label>Scheduler</label>
                            <SimpleSelect
                              className="form-control"
                              name="Scheduler"
                              value={form?.scheduler}
                              id="key"
                              label="name"
                              options={MeetingScheduler}
                              init="Select"
                              menuPortalTarget={null}
                              onChange={(selectedSchelul) => {
                                setForm((prev) => ({
                                  ...prev,
                                  scheduler: selectedSchelul.target.value,
                                }));
                              }}
                            ></SimpleSelect>
                            <span className="text-danger small">
                              {errorForm?.scheduler}
                            </span>
                          </div>
                        </Col>
                        <Col md="12">
                          <div className="form-group">
                            <label>Reviewer</label>
                            <SimpleSelect
                              className="form-control"
                              name="reviewer"
                              value={form?.reviewer}
                              id="key"
                              label="name"
                              options={MeetingReviewer}
                              init="Not Applicable"
                              menuPortalTarget={null}
                              onChange={(selectedReviewer) => {
                                // console.log("selectedReviewer", selectedReviewer)
                                setForm((prev) => ({
                                  ...prev,
                                  reviewer: selectedReviewer.target.value,
                                }));
                              }}
                            ></SimpleSelect>
                            {/* <span className="text-danger small">
                                {errorForm?.scheduler}
                              </span> */}
                          </div>
                        </Col>
                        <Col md="12">
                          <div className="form-group">
                            <label>Approver</label>
                            <SimpleSelect
                              className="form-control"
                              name="Approver"
                              value={form?.approver}
                              id="key"
                              label="name"
                              options={MeetingApprover}
                              init="Select"
                              menuPortalTarget={null}
                              onChange={(selectedApprove) => {
                                setForm((prev) => ({
                                  ...prev,
                                  approver: selectedApprove.target.value,
                                }));
                              }}
                            ></SimpleSelect>
                            <span className="text-danger small">
                              {errorForm.approver}
                            </span>
                          </div>
                        </Col>
                      </Row>

                      <div className=" text-center">
                        <Button
                          onClick={() => {
                            setShowManageModal(false);
                            if (form?.id) setShowTableModal(true);
                          }}
                          className="btn btn-secondary mr-2"
                        >
                          Close
                        </Button>
                        <Button
                          onClick={onSubmit}
                          type="submit"
                          variant="primary"
                          className="m-1 text-capitalize"
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            {/* </Srcollbar> */}
          </div>
        </div>
      </Modal>

      <Modal
        className="eventModel"
        size={"md"}
        show={showViewModal}
        onHide={() => {
          setShowViewModal(false);
        }}
      >
        <Modal.Header closeButton>
          {isMinMaxView ? (
            <Modal.Title>View Event</Modal.Title>
          ) : (
            <>
              <div className="d-flex">
                <CgFileDocument size="30" color="#4285f4" className="pr-1" />
                <Modal.Title>{form.title ? form.title : "Untitled Document"}</Modal.Title>
                {!isMinMaxView && (
                  <div className="d-flex minmaxicon">
                    <h3 className="mr-2">
                      <span
                        className="btn btn-type"
                        onClick={() => onChangePage(page - 1)}
                      >
                        {<IoMdArrowDropleftCircle />}
                      </span>{" "}
                      {page}/
                      {(form?.templates?.length + tCount) % tCount === 0
                        ? parseInt((form?.templates?.length + tCount) / tCount) - 1
                        : parseInt((form?.templates?.length + tCount) / tCount)}{" "}
                      <span
                        className="btn btn-type"
                        onClick={() => onChangePage(page + 1)}
                      >
                        {<IoMdArrowDroprightCircle />}
                      </span>
                    </h3>
                    {isMinMaxView ? (
                      <CgMaximize
                        size="20"
                        className="m-1"
                        onClick={() => {
                          setMinMaxView && setMinMaxView(false);
                        }}
                      ></CgMaximize>
                    ) : (
                      <CgMinimize
                        size="20"
                        className="m-1"
                        onClick={() => {
                          setMinMaxView && setMinMaxView(true);
                        }}
                      ></CgMinimize>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </Modal.Header>
        <div className="row p-2 docard">
          {isMinMaxView && (
            <div className="col-12">
              <Srcollbar className="modalTableFixedheight">
                <div className="card" style={{ overflow: "visible" }}>
                  <div className="card-body">
                    <Row className="mb-3">
                      {isMinMaxView && (
                        <div className="col-12">
                          <table className="table table-bordered mb-0">
                            <tbody>
                              <tr>
                                <td>Meeting Name</td>
                                <td>{form?.name}</td>
                              </tr>
                              <tr>
                                <td>Meeting Level</td>
                                <td>{form?.meetingLabel}</td>
                              </tr>

                              <tr>
                                <td>Scheduler</td>
                                <td>{form?.scheduler}</td>
                              </tr>
                              <tr>
                                <td>Reviewer</td>
                                <td>{form?.reviewer}</td>
                              </tr>
                              <tr>
                                <td>Approver</td>
                                <td>{form?.approver}</td>
                              </tr>
                            </tbody>
                          </table>
                          {/* <Row className="">
                            <Col md="12">
                              <div className="form-group d-flex">
                                <label className="pr-2">Meeting Name:</label>
                                <span>{form?.name}</span>
                              </div>
                            </Col>
                            <Col md="12">
                              <div className="form-group d-flex">
                                <label className="pr-2">Meeting Level:</label>
                                <span>{form?.meetingLabel}</span>
                              </div>
                            </Col>
                            <Col md="12">
                              <div className="form-group d-flex">
                                <label className="pr-2">Scheduler:</label>
                                <span>{form?.scheduler}</span>
                              </div>
                            </Col>
                            <Col md="12">
                              <div className="form-group d-flex">
                                <label className="pr-2">Approver:</label>
                                <span>{form?.Approver}</span>
                              </div>
                            </Col>
                          </Row> */}
                        </div>
                      )}
                    </Row>
                    {form.id && (
                      <div>
                        {/* <LogHistory
                          subModulename="ehsEvent"
                          refrenceId={form.id}
                        /> */}
                      </div>
                    )}
                    <div className="mt-2 text-center">
                      <Button
                        onClick={() => {
                          setShowViewModal(false);
                        }}
                        className="btn btn-secondary mr-2"
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              </Srcollbar>
            </div>
          )}
          {/* <div className={isMinMaxView ? "col-6" : "col-12 doc-view"}>
            <Srcollbar className="modalTableFixedheight">
              <MeetingEventTemplate
                form={form}
                setMinMaxView={setMinMaxView}
                isMinMaxView={isMinMaxView}
                pages={page}
              />
            </Srcollbar>
          </div> */}
        </div>
      </Modal>

      <Modal show={showTableModal} onHide={() => setShowTableModal(false)}>
        <div className="card">
          <Modal.Header closeButton>
            <Modal.Title>Meeting Type</Modal.Title>
          </Modal.Header>
          <div style={{ width: "200px", marginLeft: "20px", marginTop: "10px" }}>
            <input
              class="form-control"
              type="text"
              placeholder="Search here"
              onChange={handleChange}
              value={searchInput}
            />
          </div>
          <div className="card-body">
            <Srcollbar className="modalTableFixedheight">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filterData.map((data, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <span className={`${data.status === 0 ? "text-warning" : ""}`}>
                          {data.name}
                        </span>
                      </td>
                      <td>
                        <div className="actionIconsGroup">
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
                          >
                            <span
                              className="pointer text-cyanBlue icons"
                              onClick={() => {
                                viewEvent(data);
                              }}
                            >
                              <FiEye />
                            </span>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                          >
                            <span
                              className="pointer icons text-cyanBlue"
                              onClick={() => {
                                editEvent(data);
                              }}
                            >
                              <FiEdit3 />
                            </span>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                          >
                            <span
                              className="pointer icons text-danger"
                              onClick={() => {
                                deleteEventById(data.id);
                              }}
                            >
                              <FaRegTrashAlt />
                            </span>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Srcollbar>
          </div>
        </div>
      </Modal>
    </Card>
  );
};

const rules = [
  {
    field_name: "name",
    label: "Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "title",
    label: "Template Title",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "category",
    label: "Category",
    type: "string",
    isRequired: true,
  },
];

const templateRules = [
  {
    field_name: "name",
    label: "Field Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "type",
    label: "Field Type",
    type: "string",
    isRequired: true,
  },
];

const templateTableColumnRules = [
  {
    field_name: "title",
    label: "Column Title",
    type: "string",
    isRequired: true,
  },
];

const templateTableRowRules = [
  {
    field_name: "value",
    label: "Row Value",
    type: "string",
    isRequired: true,
  },
];

const MeetingFormat = {
  name: "",
  meetingLabel: "",
  scheduler: "",
  approver: "",
  templates: [],
};
const MeetingLevel = [
  { name: "Mine", key: "mine" },
  { name: "RO", key: "ro" },
  { name: "HO", key: "ho" },
];
export default MeetingType;
